import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import isDefinedAndNotNull from '@userzoomlibraries/toolkit-js-utils/is-defined-and-not-null';
import requiredParameter from '@userzoomlibraries/toolkit-js-utils/required-parameter';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Get the DOMElement of a Portal by an internal ref.
 *
 * @function
 * @param {object} ref - The ref of the internal element of the Portal.
 * @returns {HTMLElement} Returns the DOMElement of the Portal.
 * @example
 * getPortalDOMByRef(insideRef);
 * // => <PORTAL_DOM_ELEMENT>
 */

var getPortalDOMByRef = function getPortalDOMByRef() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requiredParameter('ref');

  if (isDefinedAndNotNull(ref) && ref.current) {
    return ref.current.parentNode;
  }

  return null;
};

getPortalDOMByRef.HELPER_ID = 'Gearz.Portal.getPortalDOMByRef';
getPortalDOMByRef.returnType = PropTypes.instanceOfWithDescription(HTMLElement, 'The DOM element of the portal.');
getPortalDOMByRef.parameterTypes = {
  ref: PropTypes.objectWithDescription('React ref of the portal\'s subelement.').isRequired
};
getPortalDOMByRef.defaultParameters = {};

export { getPortalDOMByRef as default };
